import { Box, Skeleton } from '@mui/material';
import HeaderFallback from './components/header.fallback';

const MarketingFallback = () => {
    return (
        <HeaderFallback title="بازاریابی">
            <Box
                sx={{
                    width: '100%',
                    maxWidth: 1180,
                    mx: 'auto',
                    display: { xs: 'block', md: 'grid' },
                    gridTemplateColumns: { md: '270px minmax(0, 1fr)' },
                    gap: 2.25,
                }}
            >
                <Box
                    sx={{
                        display: { xs: 'flex', md: 'grid' },
                        gap: 1.25,
                        overflow: 'hidden',
                        mb: { xs: 2, md: 0 },
                    }}
                >
                    {Array.from({ length: 5 }).map((_, index) => (
                        <Skeleton
                            key={index}
                            variant="rounded"
                            sx={{
                                minWidth: { xs: 210, md: 0 },
                                width: { xs: 210, md: '100%' },
                                height: 66,
                                borderRadius: '12px',
                            }}
                        />
                    ))}
                </Box>

                <Box
                    sx={{
                        p: { xs: 2.5, md: 3.5 },
                        borderRadius: '18px',
                        bgcolor: 'background.paper',
                    }}
                >
                    <Skeleton
                        variant="rounded"
                        width="100%"
                        height={112}
                        sx={{ borderRadius: '20px', mb: 2.5 }}
                    />

                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: {
                                xs: '1fr',
                                sm: 'repeat(2, 1fr)',
                                lg: 'repeat(3, 1fr)',
                            },
                            gap: 1.75,
                        }}
                    >
                        {Array.from({ length: 6 }).map((_, index) => (
                            <Skeleton
                                key={index}
                                variant="rounded"
                                height={138}
                                sx={{ borderRadius: '18px' }}
                            />
                        ))}
                    </Box>

                    <Skeleton
                        variant="rounded"
                        width="100%"
                        height={345}
                        sx={{ borderRadius: '20px', mt: 3 }}
                    />
                </Box>
            </Box>
        </HeaderFallback>
    );
};

export default MarketingFallback;
